module.exports = __webpack_public_path__ + "static/product-dna-00a45b050b303df9f829b3b5964d643b.png";